export default __webpack_public_path__ + "static/17-df6ef302a856d7c4430c3a1a2745c028.webp";